import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import {
    hasPermission,
    hasAnyPermission,
    hasAllPermissions,
    normalizePermissions,
} from '../utils/permission.utils';

export const usePermission = () => {
    const { permissions } = useSelector((state) => state.admin);
    const currentPermissions = normalizePermissions(permissions);

    const can = useCallback((requiredPermission) => {
        return hasPermission(currentPermissions, requiredPermission);
    }, [currentPermissions]);

    const canAny = useCallback((requiredPermissions) => {
        return hasAnyPermission(currentPermissions, requiredPermissions);
    }, [currentPermissions]);

    const canAll = useCallback((requiredPermissions) => {
        return hasAllPermissions(currentPermissions, requiredPermissions);
    }, [currentPermissions]);

    const cannot = useCallback((requiredPermission) => {
        return !hasPermission(currentPermissions, requiredPermission);
    }, [currentPermissions]);

    return {
        permissions: currentPermissions,
        can,
        canAny,
        canAll,
        cannot,
    };
};
